module.exports = __webpack_public_path__ + "static/media/Loveland_logo.ca7f7361.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/Loveland_logo.svg
// module id = 227
// module chunks = 0